import * as React from 'react'

import ScreenContainer from '@components/screenContainer/screenContainer'
import DeclarationDetailsMenu from '@components/menu/declarationDetailsMenu'
import DeclarationDetailsContent from '@components/content/declarationDetailsContent'

import apis from '@app/api/api'

import rights from '@utils/RightManager'

interface Props {
  navigation: Navigation
  declarationId: string
  businessId: string
}

const BusinessDetails = ({ navigation, declarationId, businessId }: Props) => {
  const [screenStatus, setScreenStatus] = React.useState<ScreenStatus>('loading')

  const [steps, setSteps] = React.useState<BusinessStep[]>([])
  const [declaration, setDeclaration] = React.useState<BusinessDeclaration | undefined>(undefined)
  const [business, setBusiness] = React.useState<BusinessDetails | undefined>(undefined)
  const [businessDetails, setBusinessDetails] = React.useState<AllBusinessDetails | undefined>(undefined)

  const [pictureName, setPictureName] = React.useState<string>('')
  const [regionList, setRegionList] = React.useState<Option[]>([])

  React.useEffect(() => {
    Promise.all([apis.business.get(businessId), apis.business.details(businessId), apis.step.list()])
      .then(([b, bDetails, s]) => {
        setBusiness(b)
        setBusinessDetails(bDetails)
        setSteps(s)
        const declaration = b.declarations.find((d) => d.id === declarationId)
        const sselected = !!declaration && s.find((st) => st.id === declaration.description.idStep)
        const tselected =
          !!declaration && !!sselected && sselected.themes.find((t) => t.id === declaration.description.idTheme)
        setPictureName(
          bDetails && sselected && tselected
            ? `${bDetails.title}_${sselected.wording}_${tselected.wording}`
            : 'Déclaration_image'
        )
        setDeclaration(declaration)
        setScreenStatus(declaration ? 'fetched' : 'error')
      })
      .catch(() => setScreenStatus('error'))
  }, [])

  React.useEffect(() => {
    if (rights.canReassignDeclarations()) {
      apis.admin.list.regions().then((fetchedRegions) => {
        setScreenStatus('fetched')
        setRegionList(fetchedRegions.regions.map((r) => ({ label: r.libelle, value: r.id })))
      })
    }
  }, [])

  return (
    <ScreenContainer
      menu={
        <DeclarationDetailsMenu
          navigation={navigation}
          screenStatus={screenStatus}
          declaration={declaration}
          setDeclaration={setDeclaration}
          business={business}
          businessDetails={businessDetails}
          steps={steps}
          regionList={regionList}
        />
      }
      content={
        <DeclarationDetailsContent
          screenStatus={screenStatus}
          declaration={declaration}
          pictureName={pictureName}
          business={business}
        />
      }
    />
  )
}

export default BusinessDetails
